import React from "react";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import AboutSoftwareDialog from "component/molecules/AboutSoftwareDialog/";
import Config from "config";

@inject("dialogStore")
@observer
class AboutSoftwareDialogContainer extends React.PureComponent {
  makeUDI(companyIDNumber, serialNumber, version) {
    return `(01)${companyIDNumber}\n(21)${serialNumber}\n(8012)${version}`;
  }
  handleRequestClose() {
    const { dialogStore } = this.props;
    dialogStore.setShowAboutSoftwareDialog(false);
  }
  render() {
    const { dialogStore } = this.props;
    const { id, serialNumber } = _.get(Config, "user", {});
    const product = _.get(Config, "product", {});
    const {
      item,
      model,
      version,
      companyAddress,
      companyIdentificationNumber,
      manufacturingPermitNumber,
      website,
    } = product;

    const UDI = this.makeUDI(
      companyIdentificationNumber,
      serialNumber,
      version
    );

    const show = dialogStore.getShowAboutSoftwareDialog();

    return (
      <AboutSoftwareDialog
        userID={id || ""}
        item={item || ""}
        model={model || ""}
        version={version || ""}
        companyAddress={companyAddress || ""}
        manufacturingPermitNumber={manufacturingPermitNumber || ""}
        serialNumber={serialNumber || ""}
        UDI={UDI || ""}
        website={website || ""}
        show={show || false}
        onRequestClose={this.handleRequestClose.bind(this)}
      />
    );
  }
}

export default AboutSoftwareDialogContainer;
